// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/video-carousel-item/video-carousel-item.component.scss
// module id = 560
// module chunks = 0